module.exports = __webpack_public_path__ + "static/media/warningMark.a3dbdfaa.svg";